import logger from 'shared/services/logger'
import Storage from './storage'

export const lastItemsFromArray = (els, n) => {
  if (typeof els === 'undefined') return null
  if (typeof n !== 'number') return null
  if (!Array.isArray(els)) return null
  return [...els].slice(Math.max(els.length - n, 0))
}

const MAX_NUMBER_OF_ELEMENTS_IN_HISTORY = 3

class SearchHistoryService {
  storage = new Storage('localStorage')
  STORAGE_KEY = 'SEARCH_HISTORY'
  isEnabled = false

  constructor() {
    this.isEnabled = this.storage.isAvailable()
    if (!this.isEnabled) {
      logger.info('SearchHistoryService is not available')
    }
  }

  get = () => {
    if (this.isEnabled) {
      return this.storage.get(this.STORAGE_KEY) || []
    }
    return []
  }
  set = value => {
    if (!this.isEnabled) {
      return []
    }

    if (!Array.isArray(value)) {
      logger.error('Value must be of type "Array"')
      // we return the current stored value as a fallback
      return this.get()
    }
    const latestEntries = lastItemsFromArray(
      value,
      MAX_NUMBER_OF_ELEMENTS_IN_HISTORY
    )

    // handle storage failure (e.g. too big)
    try {
      this.storage.set(this.STORAGE_KEY, latestEntries)
      return latestEntries
    } catch (e) {
      return false
    }
  }

  add = (...entries) => {
    if (!this.isEnabled) {
      return []
    }

    const searchHistory = this.get() || []
    entries.every(q => {
      if (searchHistory.includes(q)) {
        return searchHistory
      }
      searchHistory.push(q)
      return true
    })

    // as well handles storage failure (e.g. too big)
    return this.set(searchHistory)
  }

  clear = () => this.set([])
}

export default new SearchHistoryService()
